import { jsxs as g, jsx as e } from "react/jsx-runtime";
import { cva as p } from "class-variance-authority";
import { forwardRef as f } from "react";
import { cn as m } from "./index.es19.js";
const x = p(
  "inline-flex items-center justify-center rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-gray-100 text-gray-700 hover:bg-gray-200",
        primary: "bg-blue-100 text-blue-700 hover:bg-blue-200",
        secondary: "bg-purple-100 text-purple-700 hover:bg-purple-200",
        success: "bg-green-100 text-green-700 hover:bg-green-200",
        warning: "bg-yellow-100 text-yellow-700 hover:bg-yellow-200",
        danger: "bg-red-100 text-red-700 hover:bg-red-200",
        outline: "border border-gray-600 bg-transparent hover:bg-gray-100 text-gray-600"
      },
      size: {
        sm: "px-2.5 py-0.5 text-xs",
        md: "px-3 py-1 text-sm",
        lg: "px-4 py-2 text-base"
      },
      clickable: {
        true: "cursor-pointer",
        false: "cursor-default"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      clickable: !1
    }
  }
), y = f(
  ({ className: n, variant: i = "default", size: s = "md", clickable: o, children: b, onRemove: r, icon: l, onClick: a, ...c }, u) => {
    const t = o || !!a || !!r;
    return /* @__PURE__ */ g(
      "span",
      {
        ref: u,
        className: m(
          x({ variant: i, size: s, clickable: t }),
          n
        ),
        onClick: a,
        role: t ? "button" : void 0,
        tabIndex: t ? 0 : void 0,
        ...c,
        children: [
          l && /* @__PURE__ */ e("span", { className: "mr-1.5 inline-flex items-center", children: l }),
          /* @__PURE__ */ e("span", { children: b }),
          r && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: (d) => {
                d.stopPropagation(), r();
              },
              className: "ml-1.5 -mr-1 inline-flex rounded-full p-0.5 hover:bg-black/10 focus:outline-none focus:ring-2 focus:ring-offset-1",
              "aria-label": "Remove",
              children: /* @__PURE__ */ e("span", { className: "text-base leading-none", children: "×" })
            }
          )
        ]
      }
    );
  }
);
y.displayName = "Pill";
export {
  y as Pill
};
